import * as React from "react";
import "./PortableHeader.css";
import Autocomplete from "../../../../components/Autocomplete/Autocomplete";
import { useDispatch } from "react-redux";

import ZoomApp from "../../../../components/ZoomApp/ZoomApp";

import Logo from "../../../../assets/Logo.png";
import useSearchPlayers from "../../../../hooks/useSearchPlayers";
import FullscreenIcon from "../../../../assets/Icons/FullscreenIcon.svg?react";
import { setPortableMode } from "../../../App/actions";
import Flex from "../../../../components/Flex/Flex";
import { Suggestion } from "../../../../components/Suggestions/Suggestions";
import { Link } from "react-router-dom";
import { getPokersiteNameByPokersiteId } from "../../utils";
import Randomizer from "../../../../components/Randomizer/Randomizer";
import { useTranslation } from "react-i18next";

const PortableHeader = React.memo(() => {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const {
    nicknameToFind,
    changeNicknameToFind,
    selectPlayer,
    suggestions,
    clearAutocompletePlayers,
    autocompletePlayers,
  } = useSearchPlayers();

  const handleClosePortableMode = React.useCallback(() => {
    dispatch(setPortableMode(false));
  }, [dispatch]);

  const suggestionRenderer = React.useCallback(
    (suggestion: Suggestion) => {
      const player = autocompletePlayers.find(x => x.id === suggestion.id);
      if (player) {
        return (
          <Link
            className="Header__Suggestion"
            to={`/statistics?playername=${player?.playername}&room=${getPokersiteNameByPokersiteId(player?.pokersiteId)}`}
          >
            {suggestion.label}
          </Link>
        );
      }
    },
    [autocompletePlayers]
  );

  return (
    <Flex
      className="PortableHeader"
      gap={16}
      justify="space-between"
      align="center"
    >
      <img
        className="PortableHeader__Logo"
        src={Logo}
      />
      <ZoomApp />
      <Autocomplete
        className="PortableHeader__Autocomplete"
        inputClassName="PortableHeader__Autocomplete__Input"
        placeholder={t("search_for_players")}
        inputValue={nicknameToFind}
        onChange={changeNicknameToFind}
        onSelect={selectPlayer}
        suggestions={suggestions}
        onCloseSuggests={clearAutocompletePlayers}
        suggestionRenderer={suggestionRenderer}
      />
      <Randomizer />
      <i
        className="PortableHeader__FullscreenIcon"
        onClick={handleClosePortableMode}
      >
        <FullscreenIcon />
      </i>
    </Flex>
  );
});

export default PortableHeader;
